<!-- 上传、解析PCB文件 -->
<template>
  <div class="pcbfile">
    <el-upload
      drag
      ref="uploadRefs"
      name='file'
      :accept='accept'
      class="pcbfile-upload"
      :class="{ 'pcbfile-upload--fail': status === 3, [`pcbfile-upload__analyze3D--${status}`]: isShowAnalyze3D, 'analyzeing': analyze.analyzeing }"
      :action="url"
      :show-file-list="false"
      :before-upload="handleBeforeUpload"
      :on-progress="handleOnProgress"
      :on-success="handleOnSuccess"
      :on-error="handleOnError"
    >
      <!-- 未开始 -->
      <div v-if="status === 0" class="pcbfile-upload__notStarted">
        <div class="notStarted-content">
          <img :src="require('@@/assets/img/common/upload-img.png')" />
          <div class="notStarted-text">
            <div v-if="type === 'smt_3'">
              自己提供的PCB，请上传PCB厂的<i>最新生产文件</i>，以确保贴片的准确性
            </div>
            <div v-else>
              <b style="font-weight: bold;">上传Gerber/PCB文件</b>(或拖拽文件至此)，系统将<em>自动解析</em>计价参数
            </div>
            <p>压缩包格式(zip, rar格式),小于50MB; <span v-if="status === 0 && type !== 'smt_3'">暂不支持:CAD, Allegro, Gerber274-D, Protel98(及以下版本)的文件</span></p>
          </div>
        </div>
      </div>
      <!-- 上传中 -->
      <div v-if="status === 1" class="pcbfile-upload__uploading" @click.stop>
        <div class="pcbfile-upload__item is-default">
          <p>{{ name }}</p>
          <span>{{ viewSize }}</span>
        </div>
        <div class="uploading-progress">
          <p>
            上传中
            <span>{{ upload.progress }}%</span>
          </p>
          <el-progress
            color="#3F96F0"
            text-color="#FFFFFF"
            define-back-color="#D6D6D6"
            :stroke-width="6"
            :text-inside="false"
            :percentage="upload.progress"
          ></el-progress>
        </div>
      </div>
      <!-- 上传成功 解析中 -->
      <div v-if="status === 2" class="pcbfile-upload__success" @click.stop>
        <div class="pcbfile-upload__item is-active">
          <p>{{ name }}</p>
          <span>{{ viewSize }}</span>
        </div>
        <div class="success-analyzeing">
          <p>
            <i class="el-icon-circle-check" />
            上传成功
          </p>
          <div>
            <i class="el-icon-refresh-left" />
            文件解析中
            <span>(预计{{ analyze.countdown }}秒后解析完成，解析成功后自动生成 <b class="bold">BOM文件和坐标文件</b>)</span>
          </div>
        </div>
      </div>
      <!-- 上传失败 -->
      <div v-if="status === 3" class="pcbfile-upload__fail" @click.stop>
        <div class="pcbfile-upload__item-wrapper">
          <div class="pcbfile-upload__item is-error">
            <p>{{ name }}</p>
            <span>{{ viewSize }}</span>
          </div>
          <el-button 
              round 
              size="mini" 
              class="pcbfile-upload__button reupload" 
              @click="handleClick"
            >重新上传</el-button>
        </div>
        <div class="fail-tips">
          <div class="fail-tips__text">
            <i class="el-icon-error" />
            <span>上传失败</span>
            <p>{{ errorMsg }}</p>
          </div>
          <!-- <div class="fail-tips__btns">
            <el-button 
              round 
              size="mini" 
              class="pcbfile-upload__button reupload is-error" 
              @click="handleClick"
            >重新上传</el-button>
            <el-button 
              round 
              size="mini" 
              class="pcbfile-upload__button reset" 
              @click="handleReset"
            >重置</el-button>
          </div> -->
        </div>
      </div>
      <!-- 解析成功 -->
      <div v-if="status === 4" class="pcbfile-upload__analyze" @click.stop>
        <p v-if="analyze.list.length > 1" class="pcbfile-upload__analyze__tips">
          {{ multipleFilesTips || '识别到压缩包内有多个PCB文件，可手动选择要下单的文件' }}
        </p>
        <div class="pcbfile-upload__item-wrapper">
          <div class="pcbfile-upload__item-list">
            <div 
              v-for="item in analyze.list" 
              :key="item.key"
              :class="{ 'pcbfile-upload__item': true, 'is-active': analyze.currentKey == item.key }"
              @click="handleAnalyzeChange(item.key)"
            >
              <p>{{ item.name }}</p>
            </div>
          </div>
          <el-button 
                round 
                size="mini" 
                class="pcbfile-upload__button reupload" 
                @click="handleClick"
              >重新上传</el-button>
        </div>
        <!-- 多文件切换文件解析中 -->
        <template v-if="analyze.analyzeing">
          <div class="analyze-analyzeing">
            <i class="el-icon-refresh-left" />
            文件解析中
            <span>(预计{{ analyze.countdown }}秒后解析完成)</span>
          </div>
        </template>
        <!-- 解析完成 -->
        <template v-else>
          <div :class="`analyze-completed ${analyze.result ? 'success' : 'fail'}`">
            <!-- 有解析数据 -->
            <div v-if="analyze.result" class="analyze-completed__success">
              <i class="el-icon-circle-check"/>
              <em>解析成功，相关参数已自动填充；</em>
              <span>为确保信息无误，请核对后下单</span>
            </div>
            <!-- 没解析数据 -->
            <div v-else class="analyze-completed__fail">
              <i class="el-icon-warning-outline"/>
              <em>解析失败</em>
              <span>无法解析参数 (不影响下单)，请手动填写参数后下单</span>
            </div>
            <!-- <div>
              <el-button 
                round 
                size="mini" 
                class="pcbfile-upload__button reupload" 
                @click="handleClick"
              >重新上传</el-button>
              <el-button 
                round 
                size="mini" 
                class="pcbfile-upload__button reset" 
                @click="handleReset"
              >重置</el-button>
            </div> -->
          </div>
        </template>
      </div>
      <!-- 解析失败 -->
      <div v-if="status === 5" class="pcbfile-upload__analyze" @click.stop>
        <div class="pcbfile-upload__item-wrapper">
          <div class="pcbfile-upload__item is-active">
            <p>{{ name }}</p>
          </div>
          <el-button 
              round 
              size="mini" 
              class="pcbfile-upload__button reupload" 
              @click="handleClick"
            >重新上传</el-button>
        </div>
        <div class="analyze-completed fail">
          <div class="analyze-completed__fail">
            <i class="el-icon-warning-outline"/>
            <em>解析失败</em>
            <span>无法解析参数 (不影响下单)，请手动填写参数后下单</span>
          </div>
          <!-- <div>
            <el-button 
              round 
              size="mini" 
              class="pcbfile-upload__button reupload" 
              @click="handleClick"
            >重新上传</el-button>
            <el-button 
              round 
              size="mini" 
              class="pcbfile-upload__button reset" 
              @click="handleReset"
            >重置</el-button>
          </div> -->
        </div>
      </div>
      <!-- 修改回显 -->
      <div v-if="status === 6" class="pcbfile-upload__view" @click.stop>
        <div class="pcbfile-upload__item-wrapper">
          <div class="pcbfile-upload__item is-active">
            <p>{{ name }}</p>
          </div>
          <el-button 
            round 
            size="mini" 
            class="pcbfile-upload__button reupload" 
            @click="handleClick"
          >重新上传</el-button>
        </div>
        <!-- <div class="pcbfile-upload__view__btns">
          <el-button 
            round 
            size="mini" 
            class="pcbfile-upload__button reupload" 
            @click="handleClick"
          >重新上传</el-button>
          <el-button 
            round 
            size="mini" 
            class="pcbfile-upload__button reset" 
            @click="handleReset"
          >重置</el-button>
        </div> -->
      </div>
      
      <!-- 3D解析 -->
      <!-- <div v-if="isShowAnalyze3D" class="pcbfile-upload__analyze3D">
        <Analyze3D 
          :analyzeId="analyze_id" 
          :analyzeKey="analyze.currentKey" 
          @analyzeing="isLoading => $emit('analyzeing3D', isLoading)"
          @complete="handleAnalyze3DComplete"
        />
      </div> -->
    </el-upload>
    <!-- <p v-if="status === 0 && type !== 'smt_3'" class="pcbfile-tips">
      暂不支持：CAD, Allegro, Gerber274-D, Protel98(及以下版本)的文件
    </p> -->
  </div>
</template>

<script>
// import Analyze3D from './analyze3D.vue'

import { sensorsTrack } from '@@/utils/sensors'
import {
  HQPCB_HOST,
  fileAnalyzeResult
} from '@@/api/pcb'

// 上传
const defaultUpload = {
  progress: 0, // 上传进度百分比
  timer: null, // 上传进度百分比定时器
}
// 解析
const defaultAnalyze = {
  analyzeing: false, //解析中
  progress: 0, // 解析进度百分比
  timer: null, // 解析进度百分比定时器
  currentKey: 0, 
  list: [], // 解析成功列表
  analyzeTimer: null, // 解析接口定时器
  countdown: 60, // 解析倒计时
  countdownTimer: null, // 倒计时定时器
  timeConstant: 5000, // 进度条变化的快慢，数字越大，变化的越慢
  result: null, // 解析成功的数据
}

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'pcb'
    },
    // 是否需要解析
    needAnalyeze: {
      type: Boolean,
      default: true
    },
    // 是否需要解析3D
    needAnalyeze3D: {
      type: Boolean,
      default: false
    },
    // PCB文件名称
    pcbFileName: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: '.zip,.rar'
    }
  },
  // components: {
  //   Analyze3D
  // },
  data() {
    return {
      val: this.value,
      isShowAnalyze3D: false,
      url: `${HQPCB_HOST}/upfile?type=gerber&full_url=1`,
      status: 0, // 状态： 0-未开始, 1-上传中, 2-上传成功, 3-上传失败, 4-解析成功, 5-解析失败, 6-修改回显
      name: '', // 文件名称
      size: 0, // 单位B
      analyze_id: '', // 上传成功后返回的id
      errorMsg: '', // 上传失败提示
      upload: { ...defaultUpload },
      analyze: { ...defaultAnalyze },
      multipleFilesTips: '', // 多个文件提示
    }
  },
  computed: {
    geberviewUrl() {
      const { analyze_id, analyze } = this
      return `${HQPCB_HOST}/gerberviewer/viewer?id=${analyze_id}&key=${analyze.currentKey}`
    },
    // 文件大小
    viewSize() {
      const size = this.size
      let text = size + ' B'
      if (size > 1024) {
        text = parseInt(size / 1024) + ' KB'
      }
      if (size > 1024 * 1024) {
        text = parseInt(size / (1024 * 1024)) + ' MB'
      }
      return text
    },
  },
  watch: {
    value(newVal) {
      this.val = newVal
      if (newVal && this.status === 0) {
        this.name = this.pcbFileName || newVal.split('/').pop()
        this.status = 6
      }
    },
    'upload.progress'(val) {
      if (val >= 100) {
        this.upload.progress = 100
        clearInterval(this.upload.timer)
      }
    },
    status(newVal, oldVal) {
      // 通知事件总线解析状态的变化
      // 解析中状态(2)、解析成功(4)、解析失败(5)
      if ([0, 2, 4, 5].includes(newVal)) {
        this.$emit('pcbaFileAnalyzeStatusChange', {
          status: newVal,
          isAnalyzing: newVal === 2,
          isAnalyzeSuccess: newVal === 4,
          isAnalyzeFailed: newVal === 5
        });
      }
    }
  },
  methods: {
    handleEmit() {
      const { val, name, analyze_id } = this
      this.$emit('input', val)
      this.$emit('change', { val, name, analyze_id })
    },
    handleClick() {
      this.$refs.uploadRefs.$refs['upload-inner'].handleClick()
    },
    // 重置
    handleReset(event) {
      event && event.stopPropagation()
      if (this.upload.timer) clearInterval(this.upload.timer)
      if (this.analyze.analyzeTimer) clearInterval(this.analyze.analyzeTimer)
      if (this.analyze.countdownTimer) clearInterval(this.analyze.countdownTimer)
      this.status = 0
      this.name = ''
      this.size = 0
      this.analyze_id = ''
      this.upload = { ...defaultUpload }
      this.analyze = { ...defaultAnalyze }
      this.val = ''
      this.multipleFilesTips = ''
      this.handleEmit()
    },
    // 上传校验
    handleBeforeUpload(file) {
      const { name, size } = file
      const isLimit50M = size / 1024 / 1024 < 50
      if (isLimit50M) {
        this.status = 1
        this.upload.progress = 0
        this.analyze.progress = 0
        this.size = size
        this.name = name
      } else {
        this.$message.error('文件大小不能超过 50MB，请重新上传！')
      }
      return isLimit50M
    },
    // 上传中
    handleOnProgress(event, file) {
      // 神策数据埋点
      sensorsTrack('PCB1_quotation_UploadGerber_click', { entrance: '新版PCB计价：上传文件' })

      const toFixed_1 = val => Number(val.toFixed(1))
      // 上传进度条处理
      const percent = toFixed_1(event.percent * 0.95)
      this.upload.progress = Number(percent)
      if (event.percent == 100) {
        this.upload.timer = setInterval(() => {
          if (this.upload.progress < 100) {
            const random = toFixed_1(Math.floor(Math.random() * 10) * 0.1)
            this.upload.progress = toFixed_1(this.upload.progress + random)
          }
        }, 300)
      }
    },
    // 上传成功
    handleOnSuccess(res) {
      const { status, url, name, analyze_id, msg } = res
      if (status) {
        this.upload.progress = 100
        const timer = setTimeout(() => {
          this.analyze_id = analyze_id
          this.val = url
          this.handleEmit()
          if (this.type === 'smt_3') {
            // 不需要解析
            this.status = 6
          } else {
            this.status = 2
            this.startAnalyze()

            // 需要解析3D
            this.isShowAnalyze3D = !!(this.needAnalyeze3D && analyze_id)
          }
          clearTimeout(timer)
        }, 400)
      } else {
        this.upload.progress = 0
        this.analyze.progress = 0
        this.status = 3
        this.errorMsg = msg
      }
    },
    // 上传失败
    handleOnError() {
      this.status = 3
      this.handleReset()
    },
    
    handleAnalyzeChange(key) {
      this.isShowAnalyze3D = true
      this.$nextTick(() => {
        this.multipleFilesTips = '识别到压缩包内有多个PCB文件，请注意不要选错了'
        this.analyze.currentKey = key
        this.startAnalyze(key)
      })
    },
    // 文件解析
    startAnalyze(key) {
      this.startCountdown()
      this.startProgress()
      this.analyze.analyzeing = true
      // 触发分析状态变更事件
      this.analyze.analyzeTimer = setInterval(() => {
        const params = { analyze_id: this.analyze_id }
        fileAnalyzeResult(params, key)
          .then(res => {
            if (!res) return
            const { code, data = {} } = res
            if (code == 200) {
              const { items = [], key, result } = data
              this.analyze.currentKey = key
              this.analyze.list = items
              // 解析失败
              if (items.every(i => i.status != 1 && i.status !== 0)) {
                this.status = 5
                this.endAnalyze(5)
                return
              }

              this.analyze.result = result
              // 数据解析成功
              if (result) {
                // 如果解析出来是3层板，则设为4层
                if (result.blayer == 3) {
                  result.blayer = 4
                }
                result.file_type = result.fileType
              }

              this.endAnalyze(4)
              this.$emit('analyzeSuccess', result || { file_type: -1 })
            }
            if (code < 105) {
              this.analyzeFailed()
            }
          })
          .catch(err => {})
      }, 1500)
    },
    // 解析完成：4-解析成功 5-解析失败
    endAnalyze(status) {
      clearInterval(this.analyze.analyzeTimer)
      this.endProgress()
      this.endCountdown()
      this.analyze.analyzeing = false
      // 触发分析状态变更事件
      const timer = setTimeout(() => {
        this.status = status
        clearTimeout(timer)
      }, 500)
    },
    // 解析失败
    analyzeFailed() {
      this.endAnalyze(5)
      this.$emit('analyzeSuccess', { file_type: -1 })
    },
    // 开始倒计时
    startCountdown() {
      this.analyze.countdown = 60
      this.analyze.countdownTimer = setInterval(() => {
        this.analyze.countdown--
        // 解析时间超过60秒没结果则按解析失败处理
        if (this.analyze.countdown <= 0) {
          this.analyzeFailed()
        }
      }, 1000)
    },
    // 结束倒计时
    endCountdown() {
      clearInterval(this.analyze.countdownTimer)
      this.analyze.countdownTimer = null
    },
    // 解析进度条进度 开始
    startProgress() {
      // 定时器间隔
      const frequency = 100
      let time = 0
      this.analyze.progress = 0
      this.analyze.timer = setInterval(() => {
        time += frequency
        if (this.analyze.progress >= 1) {
          this.endProgress()
          return
        }
        this.analyze.progress = 1 - Math.exp((-1 * time) / this.analyze.timeConstant)
      }, frequency)
    },
    // 解析进度条进度 结束
    endProgress() {
      this.analyze.progress = 1
      clearInterval(this.analyze.timer)
      this.analyze.timer = null
    },
    // 3D解析完成
    handleAnalyze3DComplete(isSuccess) {
      // 解析成功后，不再显示3D解析组件
      this.isShowAnalyze3D = !isSuccess
      this.$emit('analyze3DComplete', {
        isShow: isSuccess,
        loading: false,
        analyze_id: this.analyze_id,
        key: this.analyze.currentKey
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bold{
  font-weight: bold;
}
.pcbfile-upload ::v-deep {
  .el-upload {
    display: block;
    color: $--color-text-primary;
    &:focus {
      color: $--color-text-primary;
    }
    .el-upload-dragger {
      text-align: left;
      width: 630px;
      height: auto;
      line-height: 1;
      border-radius: 3px;
      border: 0px;
      background-color: transparent;
      // border-color: $--form-color-base;
      // background-color: $--input-background-color;
      &:hover {
        border-color: $--form-color-base;
      }
    }
  }

  &.pcbfile-upload--fail {
    .el-upload-dragger {
      border-color: $--color-warning;
      background-color: #FDF6EC;
    }
  }

  .pcbfile-upload__success__name {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding: 12px;
    border-radius: 3px;
    border: 1px dashed $--color-success;
    background: #ffffff;
    &.active {
      color: $--color-success;
    }
    >img {
      width: 20px;
    }
    >p {
      flex: 1;
      margin-left: 10px;
      line-height: 18px;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    >i {
      font-size: 16px;
      color: $--color-success;
    }
  }

  .pcbfile-upload__analyzeing {
    margin: 16px 0 10px;
    font-weight: 700;
    text-align: left;
    >span {
      margin-left: 10px;
      font-weight: 400;
      color: $--color-text-secondary;
    }
  }

  .pcbfile-upload__button {
    padding: 0;
    height: 32px;
    line-height: 32px;
    width: 96px;
    font-size: 12px;
    color: #666666;
    background-color: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 3px;
    margin-left: 12px;
    flex-shrink: 0;
    &:hover {
      color: #666666!important;
    }
    &.reupload:hover {
      color: $--form-color-base;
    }
    &.reset:hover {
      color: $--color-danger;
    }
    &.is-error {
      color: #FFF;
      border-color: #FF4D4F;
      background-color: #FF4D4F;
      &:hover {
        color: #FFF;
        border-color: #EE4648;
        background-color: #EE4648;
      }
    }
  }

  .pcbfile-upload__button.el-button--text {
    color: $--color-text-secondary;
    &:hover {
      background-color: #fff;
    }
  }

  .pcbfile-upload__notStarted {
    .notStarted-content {
      border-radius: 3px;
      border: 1px dashed $--form-color-base;
      background-color: $--input-background-color;
      height: 80px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      > img {
        width: 26px;
        flex-shrink: 0;
        margin-right: 16px;
      }
      .notStarted-text {
        text-align: left;
        > div {
          margin: 4px 0 8px;
          font-size: 13px;
          color: $--color-text-primary;
          > em {
            color: $--color-warning;
            font-style: normal;
          }
          > i {
            color: $--color-danger;
          }
        }
        > p {
          font-size: 12px;
          color: $--color-text-placeholder;
        }
      }
    }
  }
  .pcbfile-upload__item {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 16px 0 12px;
    flex: 1;
    height: 42px;
    border: 1px solid #E1E1E1;
    border-radius: 3px;
    background-color: #FFF;
    & + .pcbfile-upload__item { 
      margin-top: 6px;
    }
    &::before {
      content: '';
      display: block;
      width: 18px;
      height: 14px;
      background: url('~@@/assets/img/icons/icon_file.png');
    }
    &.is-default {
      border: 1px solid #f8f8f8;
      background: #f8f8f8;
      >p {
        font-weight: 700;
      }
    }
    &.is-active {
      position: relative;
      border-color: #15A675;
      background-color: #F7FCFB;
      &::before {
        background: url('~@@/assets/img/icons/icon_file_active.png');
      }
      &::after { 
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        display: block;
        width: 20px;
        height: 14px;
        background: url('~@@/assets/img/icons/icon_radio.png');
      }
      >p {
        height: 14px;
        font-weight: 700;
      }
    }
    &.is-error {
      border-radius: 5px;
      border: 1px dashed $--color-danger;
      background-color: #fef0f0;
      overflow: hidden;
      min-width: 0;
      >p {
        height: 14px;
        font-weight: 700;
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &:hover {
      border-color: #AAAAAA;
      background-color: #FDFDFD;
      &::before {
        background: url('~@@/assets/img/icons/icon_file_hover.png');
      }
      &::after {
        display: none;
      }
      >p {
        font-weight: 700;
      }
    }
    >p {
      flex: 1;
      margin: 0 8px;
      font-size: 12px;
      color: #111111;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    >span {
      display: block;
      width: 60px;
      font-size: 12px;
      color: #AAAAAA;
      text-align: right;
    }
  }

  .pcbfile-upload__uploading {
    .pcbfile-upload__item {
      // 继承外层样式
    }
    .uploading-progress {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      text-align: left;
      margin-top: 10px;
      padding: 0 14px 0 12px;
      height: 28px;
      border-radius: 14px;
      background-color: #f4f9ff;
      >p {
        margin-right: 16px;
        width: 82px;
        font-size: 12px;
        color: #3F96F0;
        >span {
          margin-left: 4px;
        }
      }
      .el-progress {
        flex: 1;
        height: 16px;
        .el-progress-bar {
          padding-right: 0;
        }
      }
    }
  }
  .pcbfile-upload__success {
    text-align: left;
    .success-analyzeing {
      display: flex;
      align-items: center;
      margin-top: 10px;
      >p {
        margin-right: 6px;
        width: 98px;
        height: 28px;
        line-height: 28px;
        font-size: 12px;
        color: #67C23A;
        text-align: center;
        border-radius: 14px;
        background-color: #f8f8f8;
        >i {
          font-size: 14px;
          vertical-align: text-bottom;
        }
      }
      >div {
        flex: 1;
        padding-left: 13px;
        height: 28px;
        line-height: 28px;
        font-size: 12px;
        color: #3F96F0;
        border-radius: 14px;
        background: linear-gradient(270deg,#ffffff 2%, #f4f9ff 89%);
        >i {
          font-size: 14px;
          vertical-align: text-bottom;
          animation: spin 1s linear infinite;
        }
        >span {
          color: #999999;
        }
      }
    }
  }
  .pcbfile-upload__fail {
    .fail-tips {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      padding-left: 13px;
      border-radius: 14px;
      font-size: 12px;
      height: 28px;
      background: linear-gradient(90deg,#fef0f0 2%, #ffffff 89%);
      .fail-tips__text {
        display: flex;
        >i {
          font-size: 14px;
          color: $--color-danger;
        }
        >span {
          margin: 0 10px 0 5px;
          font-weight: 700;
          color: $--color-danger;
        }
        >p {
          color: #999999;
        }
      }
    }
  }
  .pcbfile-upload__analyze {
    .pcbfile-upload__item-list {
      overflow: hidden;
      min-width: 0;
    }
    .pcbfile-upload__item {
      overflow: hidden;
      min-width: 0;
      >p {
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .pcbfile-upload__analyze__tips {
      margin-bottom: 9px;
      font-size: 12px;
      color: #C08534;
    }
    .analyze-analyzeing {
      margin-top: 10px;
      padding-left: 13px;
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      color: #3F96F0;
      border-radius: 14px;
      background: linear-gradient(270deg,#ffffff 2%, #f4f9ff 89%);
      >i {
        font-size: 14px;
        vertical-align: text-bottom;
        animation: spin 1s linear infinite;
      }
      >span {
        color: #999999;
      }
    }
    .analyze-completed {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      padding-left: 13px;
      font-size: 12px;
      height: 28px;
      border-radius: 14px;
      &.success {
        background: linear-gradient(270deg,#ffffff 2%, #f8f8f8 89%);
      }
      &.fail {
        background: linear-gradient(270deg,#ffffff 2%, #fff4e3 89%);
      }
      .analyze-completed__success {
        font-size: 12px;
        >i {
          margin-right: 6px;
          font-size: 14px;
          color: #75C84D;
          vertical-align: text-bottom;
        }
        >em {
          color: #555555;
          font-style: normal;
        }
        >span {
          color: #999999;
        }
      }
      .analyze-completed__fail {
        font-size: 12px;
        >i {
          font-size: 14px;
          color: #C08534;
          vertical-align: text-bottom;
        }
        >em {
          margin: 0 8px 0 6px;
          color: #C08534;
          font-style: normal;
        }
        >span {
          color: #999999;
        }
      }
    }
  }

  .pcbfile-upload__view {
    .pcbfile-upload__item-wrapper {
      overflow: hidden;
      min-width: 0;
    }
    .pcbfile-upload__item {
      overflow: hidden;
      min-width: 0;
      >p {
        min-width: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .pcbfile-upload__view__btns {
      margin-top: 10px;
      text-align: center;
    }
  }
}

// 有3D解析
.pcbfile-upload__analyze3D--4,
.pcbfile-upload__analyze3D--5 {
  position: relative;
  .pcbfile-upload__analyze {
    .pcbfile-upload__analyze__btns {
      margin-top: 38px;
    }
  }
  .pcbfile-upload__analyze3D {
    position: absolute;
    left: 0;
    bottom: 56px;
    width: 100%;
  }
}
.pcbfile-upload__analyze3D--4.analyzeing {
  .pcbfile-upload__analyze {
    margin-bottom: 36px;
  }
  .pcbfile-upload__analyze3D {
    bottom: 20px;
  }
}

.pcbfile-tips {
  margin-top: 2px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  color: $--color-text-disabled;
  border-radius: 3px;
  background: $--background-disabled;
}

// 转圈动画
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.pcbfile-upload__item-wrapper {
  display: flex;
  align-items: center;
  overflow: hidden;
  min-width: 0;
}
.pcbfile-upload__item-list {
  flex: 1;
}
</style>